export default __webpack_public_path__ + "images/student/avatars/Hoppy-1cc7d153eeb176b61b22c7d4a3484793.svg";